/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect, useState } from 'react';
import { TbUpload } from 'react-icons/tb';
import { useDropzone } from 'react-dropzone';

import { HiOutlineTrash } from 'react-icons/hi2';
import { Container, Dropzone } from './styles';
import Input from '~/components/Input';

interface IInputFile {
  name: string;
  className?: string;
  onChange?(files: File[]): void;
  value?: string;
  multiple?: boolean;
}

const InputFile: React.FC<IInputFile> = ({
  name,
  className,
  onChange,
  value,
  multiple,
}) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const [valuePreview, setValuePreview] = useState('');
  const [isFocuses, setIsFocuses] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [isError, setIsError] = useState(false);
  const [files, setFiles] = useState<File[]>([]);

  useEffect(() => {
    if (value) {
      setValuePreview(value);
    }
  }, [value]);

  const handleChange = useCallback((e) => {
    setFiles((state) => [...state, ...e.target.files]);
  }, []);

  useEffect(() => {
    setFiles((state) => [...state, ...acceptedFiles]);
  }, [acceptedFiles]);

  useEffect(() => {
    if (onChange && files.length > 0) {
      onChange(files);
    }
  }, [files, onChange]);

  const handleClickRemove = useCallback((fileIndex) => {
    setFiles((state) => state.filter((_, index) => index !== fileIndex));
  }, []);

  return (
    <Container
      className={`${className} ${isError ? 'isError' : ''}${
        isFilled ? 'isFilled' : ''
      }${isFocuses ? 'isFocuses' : ''}`}
      isErrored={isError}
      isFilled={isFilled}
      isFocuses={isFocuses}
      active={files.length > 0}
      multiple={multiple}
    >
      <label htmlFor={name}>
        <Dropzone
          {...getRootProps({ className: 'w-100' })}
          onClick={(event) => event.stopPropagation()}
        >
          {files.length > 0 ? (
            <div>
              {files.map((file) => (
                <div className="d-flex align-items-center" title={file.name}>
                  <p className="px-3 mb-0">{file.name}</p>
                </div>
              ))}
            </div>
          ) : (
            <>
              {!multiple && value ? (
                <div className="d-flex align-items-center" title={value}>
                  <p className="px-3 mb-0">{value}</p>
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <TbUpload size={20} color="#a3a3a3" className="ms-lg-3" />
                  <p className="mb-0 w-100 text-start">
                    Subir documento (.pdf, .doc, .docx)
                  </p>
                </div>
              )}
            </>
          )}
          <input {...getInputProps()} name={name} />
        </Dropzone>
        <Input
          type="file"
          name={name}
          id={name}
          multiple={multiple}
          className="d-none"
          onChange={handleChange}
        />
      </label>
      {!multiple && files.length > 0 && (
        <button
          type="button"
          className="border-0 bg-transparent"
          onClick={() => handleClickRemove(0)}
        >
          <HiOutlineTrash size={24} color="#F3465B" />
        </button>
      )}
    </Container>
  );
};

export default InputFile;
